import client from '@/shared/api';
import { theme } from '@/shared/styles';
import LoadingOverlay from '@/shared/ui/components/LoadingOverlay';
import { ApolloProvider } from '@apollo/client';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import ModalProvider from 'mui-modal-provider';
import { SnackbarProvider } from 'notistack';
import type { ReactNode } from 'react';
import SettingsProvider from './SettingsProvider';

export const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
            {/* `suspense`+`fallback` let dialogs exported via `React.lazy()` (see Dialogs/index.tsx) show a loading
                state on first open, with zero changes needed at any `showModal()` call site. */}
            <ModalProvider suspense fallback={<LoadingOverlay active text="Loading..." />}>
              <SettingsProvider>{children}</SettingsProvider>
            </ModalProvider>
          </SnackbarProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
};
